var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510.708 510.708",
    height: 512,
    viewBox: "0 0 510.708 510.708",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.354.708c-98.131 0-158.574 55.347-158.741 55.441-3.787 17.481-10.374 42.85-10.374 61.465 0 140.833 118.763 254.972 259.596 254.972 60.017 0 115.159-27.944 158.719-62.639.178-1.087 5.801-23.477 5.801-54.239-.001-140.833-114.169-255-255.001-255z",
    fill: "#d7f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.813 365.387c-140.833 0-255-114.167-255-255 0-18.615 2.013-36.757 5.8-54.239-.006.005-.011.01-.017.014-58.645 46.72-96.242 118.738-96.242 199.546 0 86.061 42.633 162.164 107.932 208.343l15.758 1.578 8.244 13.471c36.488 20.144 78.438 31.608 123.066 31.608 36.238 0 70.847-7.601 102.23-21.353l8.882-10.255 15.975-2.301c61.138-35.201 106.571-95.114 122.113-166.852-43.56 34.695-98.725 55.44-158.741 55.44z",
    fill: "#afe6ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m2.53 247.91 165.487-90.915 65.678-3.806 22.011 102.608h-251.152c-4.348 0-5.834-5.794-2.024-7.887z",
    fill: "#64bc0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.017 156.995 86.815-47.695.874 146.497z",
    fill: "#57aa00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.11 6.326 143.596 249.47 49.48-81.378-3.809-62.304-183.441-111.477c-3.715-2.257-7.995 1.921-5.826 5.689z",
    fill: "#ff3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.378 112.114-45.672 143.683 76.115-125.183z",
    fill: "#dc1428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.556 3.206-138.849 252.59 126.734 8.364 20.002-36.592v-222.337c-.001-4.347-5.793-5.834-7.887-2.025z",
    fill: "#ffd23c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.442 227.569-146.736 28.228h146.736z",
    fill: "#ffc305"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m508.175 263.685-161.714 88.717-88.987 15.046-1.769-111.651h250.447c4.351 0 5.836 5.796 2.023 7.888z",
    fill: "#ffa50a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.462 352.401-90.567 49.685-.189-146.289z",
    fill: "#fa870a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.583 489.353c8.535-3.74 16.831-7.935 24.857-12.556l-126.734-221-60.395 98.281 13.6 44.928z",
    fill: "#6e64c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.911 399.006 46.795-143.209-76.799 124.976z",
    fill: "#5046af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.286 464.05c7.697 5.443 15.709 10.47 24.003 15.049l123.418-223.302-116.139 13.03-31.281 13.03v182.193z",
    fill: "#2896ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.286 281.857 147.42-26.06h-147.42z",
    fill: "#1e87dc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignv);
export default __webpack_public_path__ + "static/media/designv.9f215bcea6123805b94a251910d286f5.svg";
export { ForwardRef as ReactComponent };